import { Select, MenuItem, FormControl, InputLabel, Grid } from '@mui/material';
import React from 'react';
import { getGstFinancialYears } from 'utils/FinancialYears';

const FinancialYearAndMonthSelector = ({ selectedYear, setSelectedYear, selectedMonth, setSelectedMonth },) => {


    // Calculate the current financial year
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth();
    const startFinancialYear = currentMonth >= 3 ? currentYear : currentYear - 1; // Financial year starts from April

    // Generate the list of financial years from 2017-2018 to the current financial year
    const financialYears: string[] = [];
    for (let year = startFinancialYear; year >= 2017; year--) {
        financialYears.push(`${year}-${(year + 1).toString().slice(2)}`);
    }

    // Months from April to March
    const months = ['April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December', 'January', 'February', 'March'];

    const handleYearChange = (event) => {
        setSelectedYear(event.target.value);
    };

    const handleMonthChange = (event) => {
        setSelectedMonth(event.target.value);
    };

    const formatMonthNumber = (monthNumber) => monthNumber < 10 ? `0${monthNumber}` : `${monthNumber}`;


    return (
        <Grid container display='flex' justifyContent='flex-start'>
            <Grid item xs={6} >
                <FormControl fullWidth>
                    <InputLabel>FY</InputLabel>
                    <Select
                        label="FY"
                        value={selectedYear}
                        onChange={handleYearChange}
                        sx={{ width: '90%', height: 40 }}
                    >
                        {getGstFinancialYears().map((year) => (
                            <MenuItem key={year} value={year}>
                                {year}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>
            <Grid item xs={6}>
                <FormControl fullWidth>
                    <InputLabel>Month</InputLabel>
                    <Select
                        label="Month"
                        value={selectedMonth}
                        onChange={handleMonthChange}
                        sx={{ width: "90%", height: 40 }}
                    >
                        {months.map((month, index) => (
                            <MenuItem key={index} value={(formatMonthNumber(index + 1 + 3 > 12 ? (index + 1 + 3) - 12 : (index + 1 + 3)))}>
                                {month}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>
        </Grid>
    );
}

export default FinancialYearAndMonthSelector;



